import Toolbar from '@mui/material/Toolbar';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {useNavigate} from 'react-router-dom';
import paella from '../static/images/paella.jpg'

export default function ImageFullScreen() {

  const navigate = useNavigate();
  return <>
    <AppBar position="static">
      <Toolbar>
        <ArrowBackIcon onClick={() => navigate(-1)}/>
        <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
        </Typography>
        <CloseIcon/>

      </Toolbar>
    </AppBar>
    {/*<CommonAppbar isMainPage={false} pageHeader={"Image"}/>*/}
    <img src={paella} style={{'max-width': '100%', 'text-align': 'center'}} alt={'Image'}></img>
  </>
}
